import * as React from "react";
import {useNavigate} from "react-router-dom";
import {VeboxModels} from "../../types/veboxModels";
import {GREEN, RED} from "../UserManagement";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import {Tooltip} from "@vebox/etui-core";

declare var AppTranslations: AppTranslations;

export const UserListElement: React.FC<any> = (props: {
    user: VeboxModels.User
}) => {
    const navigate = useNavigate();
    const {user} = props;

    const showUserDetails = () => {
        navigate("/" + user.guid, {state: user, relative: "route"})
    }

    return (
        <div
            key={user.guid + " - element"}
            className={"user-list-element-container " + (!user.visible ? "with-icon" : "no-icon")}
            onClick={showUserDetails}
        >
            <div className="status" style={{backgroundColor: user.enabled ? GREEN : RED}}/>
            <p
                className="surname-name"
            >{user?.surname + " " + user?.name}</p>
            <p
                className="icon"
            >
                {!user.visible && (<Tooltip
                    key={user.guid + " - tooltip"}
                    message={AppTranslations.userCreationProcess.invisibleUser}
                    placement={"left"}
                >
                    <span className="material-icons-outlined">visibility_off</span>
                </Tooltip>)}
            </p>
            <p className="email">
                {user.email ?? AppTranslations.errorMessages.emailNotAvailable}
            </p>
        </div>
    )
}